import React from "react";
import {
  intro_steps_1,
  intro_steps_2,
  intro_steps_3,
} from "./constants/autotablesData";
import styles from "./AutoTables.module.scss";
import { type Stage, type StepContent } from "../../types";
import autotables_2 from "./assets/autotables_2.png";
import { StageSection } from "../StageSection";
import { StepRenderer } from "../StepRenderer";
import { useUiStore } from "@/shared/stores/uiStore";
import { useServiceWorkflowStore } from "@/shared/stores/serviceWorkflowStore";
import { Card } from "@/shared/ui";

interface IntroProps {
  copyProps: {
    resolveBlockValue: (block: StepContent) => string;
    onCopy: (value: string) => void;
  };
  setStage: (stage: Stage) => void;
}

export const IntroSection: React.FC<IntroProps> = ({ copyProps, setStage }) => {
  const { openModal } = useUiStore();
  const { onTokenAddedCallback, pId } = useServiceWorkflowStore();

  return (
    <Card variant="narrow">
      <div className={styles.introContent}>
        <h2 className={styles.sectionMainTitle}>АвтоТаблица - лучшая ОП</h2>
        <div className={styles.sectionText}>
          Экономьте время и получайте чистые, готовые к анализу данные по
          артикулам, склейкам и метрикам в одном месте
        </div>
        <div className={styles.sectionImage}>
          <iframe
            src="https://rutube.ru/play/embed/3298e9d5ae80d57a152550de1cbc9263"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            title="Embedded youtube"
          />
        </div>

        <StageSection
          title="5 минут и таблица уже работает!"
          steps={intro_steps_1}
          StepRenderer={StepRenderer}
          copyProps={copyProps}
        />
        <div className={styles.sectionImage}>
          <img src={autotables_2} alt="" loading="lazy" />
        </div>
        <StageSection
          title="Какие показатели?"
          steps={intro_steps_2}
          StepRenderer={StepRenderer}
          copyProps={copyProps}
        />
        <div className={styles.separatedBlock}>
          <StageSection
            title="Преимущества"
            steps={intro_steps_3}
            StepRenderer={StepRenderer}
            copyProps={copyProps}
            useDots={true}
          />
          <div className={styles.sectionText}>
            Превратите хаос данных в четкие решения.
          </div>
        </div>

        <div className={styles.buttonsWrap}>
          {pId ? (
            <button
              className={styles.primaryButton}
              onClick={() => {
                window.scrollTo({ top: 0, behavior: "smooth" });
                setStage("stage_1");
              }}
            >
              Подключить
            </button>
          ) : (
            <button
              className={styles.primaryButton}
              onClick={() =>
                openModal("TOKEN", { onTokenAdded: onTokenAddedCallback })
              }
            >
              Добавить токен
            </button>
          )}
          <button
            className={styles.secondaryButton}
            onClick={(e) => {
              e.preventDefault();
              window.open("https://t.me/selleralarm_support_bot", "_blank");
            }}
          >
            Поддержка
          </button>
        </div>
      </div>
    </Card>
  );
};
